import { Course } from '../core/types';
import { createTariffCard } from './tariff-card';
import { createElement, appendChildren } from '../utils/dom-helpers';
import { getCourseLinkById } from '../../../../pages/catalog/assets/js/utils/course-by-id';
import { getYmGoal } from '../../../../pages/catalog/assets/js/utils/helpYmGoals';

/**
 * Генерирует DOM-элемент мобильной модалки тарифов
 */
export function createTariffModalMob(course: Course): HTMLElement {
  // Фильтрация тарифов по is_active (0, false, пустой — пропускать)
  const filteredTariffs = (course.tariffs || []).filter(tariff => tariff.is_active !== 0 && tariff.is_active !== false && tariff.is_active !== '' && tariff.is_active !== undefined && tariff.is_active !== null);
  const modal = createElement('div', 'tarif__modal');

  // Header
  const header = createElement('div', 'modal__header');
  const headerInfo = createElement('div', 'header__info');
  const title = createElement('p', 'header__info__title');
  title.textContent = 'Тарифы';
  const desc = createElement('p', 'header__info__description');
  desc.textContent = course.short_title || course.title || 'Выберите подходящий тариф';
  // Получаем ссылку на курс через getCourseLinkById
  let aboutBtn: HTMLElement | null = null;
  const courseLink = getCourseLinkById(course.id);
  if (courseLink) {
    aboutBtn = createElement('a', 'header__info__about', {
      href: courseLink,
    });
    aboutBtn.textContent = 'О курсе';
    const ymGoal = getYmGoal('modal_about');
    if (ymGoal) aboutBtn.setAttribute('data-ym-goal', ymGoal);
    aboutBtn.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
  // } else {
  //   aboutBtn = createElement('button', 'header__info__about', {
  //     type: 'button',
  //     'data-action': 'open-modal',
  //     'data-modal-type': 'about',
  //     'data-course-id': String(course.id),
  //   });
  //   aboutBtn.textContent = 'О курсе';
  }
  appendChildren(headerInfo, title, desc);
  if (aboutBtn) {
    appendChildren(headerInfo, title, desc, aboutBtn);
  }
  header.appendChild(headerInfo);

  // Переключатель тарифов (свайпер)
  if (filteredTariffs.length) {
    const tarifSwitcher = createElement('div', 'header__tarif__switcher');
    const items = createElement('div', 'header__tarif__switcher__items');
    filteredTariffs.forEach(tariff => {
      const p = createElement('p', '');
      p.setAttribute('data-tarif', String(tariff.id));
      p.textContent = tariff.title;
      items.appendChild(p);
    });
    tarifSwitcher.appendChild(items);
    header.appendChild(tarifSwitcher);
  }

  // Проверяем, все ли тарифы имеют только полную цену
  const hasAllFullPriceOnly = filteredTariffs.every(tariff => 
    ((tariff.price_total || tariff.new_price_total) && !tariff.price_per_module && !tariff.new_price_per_module) ||
    (tariff.price_total && tariff.price_per_module && tariff.price_total === tariff.price_per_module) ||
    (tariff.new_price_total && tariff.new_price_per_module && tariff.new_price_total === tariff.new_price_per_module) ||
    tariff.is_show_as_course === true || tariff.is_show_as_course === 1 || tariff.is_show_as_course === '1'
  );
  
  // Проверяем, нужно ли показывать как курс (скрыть переключатель цен)
  const isShowAsCourse = course.is_show_as_course === true || course.is_show_as_course === 1 || course.is_show_as_course === '1';
  
  // Переключатель цен
  const priceSwitcher = createElement('div', 'header__price__switcher');
  
  if (!hasAllFullPriceOnly && !isShowAsCourse) {
    // Если есть разные цены, создаём обычный переключатель с двумя опциями
    const monthly = createElement('div', 'switcher__item active', { 'data-price': 'monthly' });
    monthly.innerHTML = '<p>Помесячно</p>';
    
    const all = createElement('div', 'switcher__item', { 'data-price': 'all' });
    if (course.id === 1863 || course.id === 1864 || course.id === 1865 || course.id === 1866 || course.id === 1867 || course.id === 1868 || course.id === 1869 || course.id === 1870) {
      all.innerHTML = '<p>Год обучения</p>';
    } else {
      all.innerHTML = '<p>Сразу весь курс</p>';
    }
    const ymGoalFull = getYmGoal('full');
    if (ymGoalFull) all.setAttribute('data-ym-goal', ymGoalFull);
    all.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
    
    if (course.total_price_discount || course.total_percent_discount ) {
      const discountValue = course.total_price_discount || course.total_percent_discount || 0;
      
      if (discountValue > 0) {
        const sticker = createElement('div', 'discount__sticker');
        sticker.innerHTML = `<span class="discount">-${discountValue}%</span>`;
        all.appendChild(sticker);
      }
    }
    
    appendChildren(priceSwitcher, monthly, all);
  } else {
    // Если все тарифы имеют только полную цену,
    // создаём переключатель только с опцией "Сразу весь курс"
    const all = createElement('div', 'switcher__item active', { 'data-price': 'all' });
    if (course.id === 1863 || course.id === 1864 || course.id === 1865 || course.id === 1866 || course.id === 1867 || course.id === 1868 || course.id === 1869 || course.id === 1870) {
      all.innerHTML = '<p>Год обучения</p>';
    } else {
      all.innerHTML = '<p>Сразу весь курс</p>';
    }
    const ymGoalFull = getYmGoal('full');
    if (ymGoalFull) all.setAttribute('data-ym-goal', ymGoalFull);
    all.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
    
    if (course.total_price_discount || course.total_percent_discount) {
      const discountValue = course.total_price_discount || course.total_percent_discount || 0;
      
      if (discountValue > 0) {
        const sticker = createElement('div', 'discount__sticker');
        sticker.innerHTML = `<span class="discount">-${discountValue}%</span>`;
        all.appendChild(sticker);
      }
    }
    
    appendChildren(priceSwitcher, all);
    
    // Активируем отображение полной цены для всех тарифов
    setTimeout(() => {
      const tariffItems = document.querySelectorAll('.tariff__items .tarif');
      tariffItems.forEach(item => {
        const priceBlock = item.querySelector('.tarif__price');
        if (priceBlock) {
          const monthlyPrice = priceBlock.querySelector('.monthly-price');
          const fullPrice = priceBlock.querySelector('.full-price');
          if (monthlyPrice) monthlyPrice.classList.remove('active');
          if (fullPrice) {
            fullPrice.classList.add('active');
            (fullPrice as HTMLElement).style.display = 'flex';
          }
        }
      });
    }, 0);
  }
  
  // Если is_show_as_course, скрываем переключатель цен
  if (isShowAsCourse) {
    priceSwitcher.style.display = 'none';
    // Активируем отображение полной цены для всех тарифов
    setTimeout(() => {
      const tariffItems = document.querySelectorAll('.tariff__items .tarif');
      tariffItems.forEach(item => {
        const priceBlock = item.querySelector('.tarif__price');
        if (priceBlock) {
          const monthlyPrice = priceBlock.querySelector('.monthly-price');
          const fullPrice = priceBlock.querySelector('.full-price');
          if (monthlyPrice) monthlyPrice.classList.remove('active');
          if (fullPrice) {
            fullPrice.classList.add('active');
            (fullPrice as HTMLElement).style.display = 'flex';
          }
        }
      });
    }, 0);
  }
  
  header.appendChild(priceSwitcher);

  // Кнопка закрытия
  const closeBtn = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  closeBtn.setAttribute('class', 'close__modal');
  closeBtn.setAttribute('width', '40');
  closeBtn.setAttribute('height', '40');
  closeBtn.setAttribute('viewBox', '0 0 40 40');
  closeBtn.setAttribute('fill', 'none');
  closeBtn.innerHTML = '<path d="M29.002 13.8281L22.8291 20.001L29.001 26.1729L26.1729 29.002L20.001 22.8291L13.8291 29.002L11.001 26.1729L17.1719 20.001L11 13.8281L13.8281 11L20.001 17.1729L26.1738 11L29.002 13.8281Z" fill="#808080" />';
  const ymGoalClose = getYmGoal('close_tariff');
  if (ymGoalClose) closeBtn.setAttribute('data-ym-goal', ymGoalClose);
  closeBtn.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
  header.appendChild(closeBtn);

  modal.appendChild(header);

  // Body
  const body = createElement('div', 'modal__body');
  const items = createElement('div', 'tariff__items swiper');
  const swiperWrapper = createElement('div', 'swiper-wrapper');
  if (filteredTariffs.length) {
    filteredTariffs.forEach((tariff, index) => {
      const card = createTariffCard(tariff, course, index);
      card.classList.add('swiper-slide');
      swiperWrapper.appendChild(card);
    });
  } else {
    const empty = createElement('div', 'tarif swiper-slide');
    empty.textContent = 'Тарифы для данного курса недоступны.';
    swiperWrapper.appendChild(empty);
  }
  items.appendChild(swiperWrapper);
  body.appendChild(items);

  // Сравнение тарифов (swiper) - мобильная версия с отдельными слайдами
  const comparison = createElement('div', 'tariff__compare swiper');
  comparison.style.display = 'none';

  // Новый вариант: строим сравнение по benefits, как в PHP
  if (filteredTariffs.length && course.benefits && course.benefits.length) {
    // Собираем все уникальные benefits по id
    const allBenefits: Record<string, any> = {};
    filteredTariffs.forEach(tariff => {
      if (Array.isArray(tariff.benefits_tariff)) {
        tariff.benefits_tariff.forEach(benefit => {
          allBenefits[benefit.id] = benefit;
        });
      }
    });
    // colorClasses не нужны для мобильного варианта

    const comparisonWrapper = createElement('div', 'swiper-wrapper');
    filteredTariffs.forEach((tariff) => {
      const compareItem = createElement('div', 'compare__item swiper-slide');
      const compareContent = createElement('ul', 'compare__content');
      Object.values(allBenefits).forEach((benefit: any) => {
        let hasBenefit = false;
        if (Array.isArray(tariff.benefits_tariff)) {
          hasBenefit = tariff.benefits_tariff.some(b => String(b.id) === String(benefit.id));
        }
        const row = createElement('li', 'compare__content__row');
        const ymGoal = getYmGoal('option');
        if (ymGoal) row.setAttribute('data-ym-goal', ymGoal);
        row.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
        const main = createElement('div', 'compare__main');
        // Добавляем compare__opener SVG
        const opener = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        opener.setAttribute('class', 'compare__opener');
        opener.setAttribute('width', '24');
        opener.setAttribute('height', '24');
        opener.setAttribute('viewBox', '0 0 24 24');
        opener.setAttribute('fill', 'none');
        opener.innerHTML = `
          <circle cx="12" cy="12" r="12" fill="white" />
          <g clip-path="url(#clip0_2604_4736)">
            <path d="M13.5 10.5H18V13.5H13.5V18H10.5V13.5H6V10.5H10.5V6H13.5V10.5Z" fill="#808080" />
          </g>
          <defs>
            <clipPath id="clip0_2604_4736">
              <rect width="12" height="12" fill="white" transform="translate(6 6)" />
            </clipPath>
          </defs>
        `;
        main.appendChild(opener);
        const title = createElement('p', 'compare__title');
        title.textContent = benefit.title;
        main.appendChild(title);

        const block = createElement('div', 'compare__block');
        // Только класс false, если нет бенефита, иначе без класса
        const item = createElement('div', hasBenefit ? 'compare__block__item' : 'compare__block__item false');
        if (hasBenefit) {
          item.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M21.8418 5.93945L13.5654 19.7334L10.4355 20.1191L2.15918 11.8418L4.9873 9.01367L11.4521 15.4785L18.4121 3.88086L21.8418 5.93945Z" fill="white" /></svg>`;
        } else {
          item.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.002 5.82812L14.8291 12.001L21.001 18.1729L19.5869 19.5869L18.1729 21.002L12.001 14.8291L5.8291 21.002L4.41504 19.5869L3.00098 18.1729L9.17188 12.001L3 5.82812L5.82812 3L12.001 9.17285L18.1738 3L21.002 5.82812Z" fill=\"#808080\" /></svg>`;
        }
        block.appendChild(item);
        main.appendChild(block);
        row.appendChild(main);

        const desc = createElement('p', 'compare__description');
        desc.textContent = benefit.description || '';
        row.appendChild(desc);

        compareContent.appendChild(row);
      });
      compareItem.appendChild(compareContent);
      comparisonWrapper.appendChild(compareItem);
    });
    comparison.appendChild(comparisonWrapper);
  }
  body.appendChild(comparison);

  modal.appendChild(body);

  // Footer
  const footer = createElement('div', 'modal__footer');
  
  // Кнопка сравнения тарифов
  const compareBtn = createElement('button', 'btn-brdrd black', {
    id: 'tarif-compare',
    'data-action': 'toggle-tariff-comparison',
  });
  compareBtn.textContent = filteredTariffs.length === 1 ? 'Подробнее' : 'Сравнить тарифы';
  const ymGoalCompare = getYmGoal('compare');
  if (ymGoalCompare) compareBtn.setAttribute('data-ym-goal', ymGoalCompare);
  compareBtn.setAttribute('data-ym-params', `{"course_id":"${course.id}"}`);
  footer.appendChild(compareBtn);
  
  // Пагинация (если тарифов больше одного)
  if (filteredTariffs.length > 1) {
    const pagination = createElement('div', 'custom-pagination');
    filteredTariffs.forEach((_, index) => {
      const paginationItem = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      paginationItem.setAttribute('class', `custom-pagination__item${index === 0 ? ' active' : ''}`);
      paginationItem.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      paginationItem.setAttribute('width', '11');
      paginationItem.setAttribute('height', '10');
      paginationItem.setAttribute('viewBox', '0 0 11 10');
      paginationItem.setAttribute('fill', 'none');
      paginationItem.innerHTML = '<circle opacity="0.3" cx="5.5" cy="5" r="5" fill="black" />';
      pagination.appendChild(paginationItem);
    });
    footer.appendChild(pagination);
  }
  
  // Информация о помощи
  const footerInfo = createElement('div', 'modal__footer__info');
  const help = createElement('p', '');
  help.textContent = 'Нужна помощь с выбором?';
  const callback = createElement('p', '');
  callback.setAttribute('data-action', 'callback-modal');
  callback.textContent = 'Оставить заявку';
  appendChildren(footerInfo, help, callback);
  footer.appendChild(footerInfo);
  
  modal.appendChild(footer);

  return modal;
} 